import React from 'react';
import { Box, Grid } from '@mui/material';
import { MediaImage } from '../../../types/media.types';
import { ImageCard } from './ImageCard';

interface ImageGridProps {
  images: MediaImage[];
  onImageClick?: (image: MediaImage) => void;
}

export const ImageGrid: React.FC<ImageGridProps> = ({ images, onImageClick }) => {
  return (
    <Box>
      <Grid container spacing={2}>
        {images.map((image) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2} key={image.id}>
            <ImageCard image={image} onClick={onImageClick} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
